module.exports = __webpack_public_path__ + "img/role01.e5c1746f.png";